import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import RemoveIcon from '@mui/icons-material/HeartBroken'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Grid,
    LinearProgress,
    Paper,
    Stack,
    Typography,
    useTheme,
} from '@mui/material'
import { boardColors } from '../sharedComponents/src/globalHeader/theme/colors'
import { getDesignTokens } from '../theme/theme'

import { useState } from 'react'
import theme from '../sharedComponents/src/Theme/theme-v2'

const CollapsibleBlock = ({ children, title }: { children: React.ReactNode; title: string }) => {
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    )
}

let themes = {
    old: getDesignTokens('light', boardColors.default),
    new: theme,
}

export const ComponentsView = () => {
    const [color, setColor] = useState<'primary' | 'secondary' | 'error'>('primary')
    const theme = useTheme()

    return (
        <Stack direction="column" gap={0} m="0 auto" p={2} maxWidth={1200} width="100%">
            <Typography variant="h5" paragraph>
                Color
            </Typography>
            <Grid container direction="row" spacing={1} mb="-2px" px={1} zIndex={0}>
                {['primary', 'secondary', 'error'].map((item, index) => (
                    <Grid item xs={4} key={index + item}>
                        <Button
                            tab
                            selected={item === color}
                            variant={item === color ? 'contained' : 'outlined'}
                            color={item as any}
                            onClick={() => setColor(item as any)}
                            fullWidth
                            // size="large"
                        >
                            {item}
                        </Button>
                    </Grid>
                ))}
            </Grid>
            <Paper sx={{ zIndex: 2 }} variant="outlined">
                {/* <Box display="flex"> */}

                {/* </Box> */}
                <br />
                <Typography variant="h6">Color palette</Typography>
                <Grid container spacing={2}>
                    {['light', 'main', 'dark'].map((item, index) => (
                        <Grid item xs={4} key={index}>
                            <Paper
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    backgroundColor: `${color}.${item}`,
                                    color: 'common.black',
                                }}
                            >
                                {theme.palette[color][item]}
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Paper>
            <br />
            <Typography variant="h5" paragraph>
                Components
            </Typography>
            <Paper sx={{ p: 0, overflow: 'hidden', '> p': { p: 2 } }} variant="outlined">
                <CollapsibleBlock title="Buttons">
                    <Paper variant="outlined" key={color}>
                        <Box display="flex" gap={2} flexWrap="wrap" flexDirection="column">
                            <Box display="flex" gap={2} flexWrap="wrap">
                                {[
                                    {
                                        text: 'disabled',
                                        variant: 'contained',
                                        color,
                                        size: 'small',
                                        disabled: true,
                                    },
                                    { text: 'selected', variant: 'outlined', color, size: 'small', selected: true },
                                    { text: 'outlined', variant: 'outlined', color, size: 'small' },
                                    { text: 'small', variant: 'contained', color, size: 'small' },
                                    { text: 'medium', variant: 'contained', color, size: 'medium' },
                                    { text: 'large', variant: 'contained', color, size: 'large' },
                                    { text: 'large', variant: 'contained', color, size: 'large', badge: true },
                                    { text: 'large', variant: 'contained', color, size: 'large', animated: true },
                                    {
                                        text: 'full width large',
                                        variant: 'contained',
                                        selected: true,
                                        color,
                                        size: 'large',
                                        fullWidth: true,
                                    },
                                ].map((buttonItem, index) => (
                                    // @ts-ignore
                                    <Button
                                        id={`${color}-${index}`}
                                        key={`${color}-${index}`}
                                        startIcon={<RemoveIcon />}
                                        endIcon={<RemoveIcon />}
                                        {...buttonItem}
                                    >
                                        {buttonItem.text}
                                    </Button>
                                ))}
                            </Box>
                            <Box display="flex" gap={2} flexWrap="wrap">
                                {[
                                    { onlyIcon: true, variant: 'contained', color, size: 'small', disabled: true },
                                    { onlyIcon: true, variant: 'outlined', color, size: 'small', selected: true },
                                    { onlyIcon: true, variant: 'outlined', color, size: 'small' },
                                    { onlyIcon: true, variant: 'contained', color, size: 'small' },
                                    { onlyIcon: true, variant: 'contained', color, size: 'medium' },
                                    { onlyIcon: true, variant: 'contained', color, size: 'large' },
                                ].map((buttonItem, index) => (
                                    // @ts-ignore
                                    <Button startIcon={<RemoveIcon />} key={index} {...buttonItem}></Button>
                                ))}
                            </Box>
                        </Box>
                    </Paper>
                </CollapsibleBlock>

                <CollapsibleBlock title="Progress Bar">
                    <Paper variant="outlined" sx={{ p: 2 }}>
                        <Typography variant="h6">Small</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <LinearProgress variant="determinate" color={color} value={0} meter />
                            </Grid>
                            <Grid item xs={6}>
                                <LinearProgress variant="determinate" color={color} value={33} meter />
                            </Grid>
                        </Grid>
                        <br />
                        <Typography variant="h6">Medium</Typography>
                        <LinearProgress size="medium" variant="determinate" color={color} value={33} meter />
                        <br />
                        <Typography variant="h6">Large</Typography>
                        <LinearProgress size="large" variant="determinate" color={color} value={100} meter />
                    </Paper>
                </CollapsibleBlock>

                <CollapsibleBlock title="Typography">
                    <Paper variant="outlined" sx={{ p: 2 }}>
                        <Box display="flex" gap={2} flexWrap="wrap" flexDirection="column">
                            <Typography variant="h1" color={color} paragraph>
                                H1: Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            </Typography>
                            {['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2'].map(
                                (item, index) => (
                                    // @ts-ignore
                                    <Typography variant={item} key={index} paragraph>
                                        {item}: Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </Typography>
                                ),
                            )}
                        </Box>
                    </Paper>
                </CollapsibleBlock>
            </Paper>
        </Stack>
    )
}
